import { Injectable } from '@angular/core';
import type { InquiryRequest } from 'src/app/request-information/models';
import { LocalStorageService, StorageItem } from 'src/app/shared/services/local-storage.service';
import { CommonUtils } from 'src/app/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class FamilyBookingService {
  private isSignUpPrefillEnabled = false;

  constructor(private readonly localStorageService: LocalStorageService) {}

  setInquiry(inquiry: InquiryRequest): void {
    this.localStorageService.setItem(StorageItem.PendingInquiry, inquiry);
  }

  getInquiry(): InquiryRequest | null {
    return this.localStorageService.getItem(StorageItem.PendingInquiry) ?? null;
  }

  isInquiryOwnedBy(emailAddress?: string): boolean {
    return CommonUtils.isSameText(this.getInquiry()?.emailId, emailAddress);
  }

  clearInquiry(): void {
    this.localStorageService.removeItem(StorageItem.PendingInquiry);
    this.isSignUpPrefillEnabled = false;
  }

  enableSignUpPrefill(): void {
    this.isSignUpPrefillEnabled = true;
  }

  disableSignUpPrefill(): void {
    this.isSignUpPrefillEnabled = false;
  }

  getInquiryForSignUpPrefill(): InquiryRequest | null {
    return this.isSignUpPrefillEnabled ? this.getInquiry() : null;
  }

  getInquiryForSignUp(signedUpEmail?: string): InquiryRequest | null {
    const inquiry = this.getInquiry();
    if (!inquiry) {
      return null;
    }
    return this.isSignUpPrefillEnabled || CommonUtils.isSameText(signedUpEmail, inquiry.emailId) ? inquiry : null;
  }
}
